import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <img
              src="/logo.svg"
              alt="SULH Logo"
              className="h-16 w-auto mb-4"
             
            />
            <p className="text-gray-400 text-sm mb-4">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-blue-400 text-sm transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-blue-400 text-sm transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/penetration-testing" className="text-gray-400 hover:text-blue-400 text-sm transition-colors">
                  Penetration Testing
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-blue-400 text-sm transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Penetration Testing</li>
              <li className="text-gray-400 text-sm">SIEM Solutions</li>
              <li className="text-gray-400 text-sm">IDS/IPS</li>
              <li className="text-gray-400 text-sm">Vulnerability Assessment</li>
              <li className="text-gray-400 text-sm">Security Training</li>
              <li className="text-gray-400 text-sm">Malware Analysis</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <span>info@sulh.tech</span>
              </li>
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span>+90 (232) 343-44 00</span>
              </li>
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Erzene Mahallesi, Ankara Cad<br />
                      Ege Üniversitesi Teknopark<br />
                      Ebiltem Binası<br /> 
                      No:172/14<br />
                      35040 Bornova<br />
                      TÜRKİYE</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 SULH ARGE EGITIM DANISMANLIK ITH. IHR. LTD. STI.<br />
              <br />
              All rights reserved. 
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <span className="text-gray-400 text-xs">SOC II Compliant</span>
              <span className="text-gray-400 text-xs">TSE-Integrated</span>
              <span className="text-gray-400 text-xs">ISO 27001 Certified</span>
              <span className="text-gray-400 text-xs">PCI DSS Compliant</span>
              <span className="text-gray-400 text-xs">GDPR Compliant</span>
              <span className="text-gray-400 text-xs">KVKK Compliant</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
